export default "__VITE_ASSET__e568b3e8__"